var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoVerificationImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 219,
    viewBox: "0 0 307 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.416 216.311H244.559C253.396 216.311 260.559 209.148 260.559 200.311V169.163",
    stroke: "#656B76",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2734 169.163V200.311C46.2734 209.148 53.4369 216.311 62.2734 216.311H93.4163",
    stroke: "#656B76",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4163 2H62.2735C53.4369 2 46.2734 9.16344 46.2734 18V49.1485",
    stroke: "#656B76",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.559 49.1485V18C260.559 9.16344 253.396 2 244.559 2H213.416",
    stroke: "#656B76",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4613 188.97C72.4613 178.478 76.237 160.87 101.536 160.87C112.447 160.87 120.684 157.222 126.028 150.034C129.976 144.723 132.243 137.565 132.8 128.719C140.124 134.629 147.706 138.174 153.543 138.174C159.38 138.174 166.978 134.617 174.311 128.697C174.868 137.561 177.136 144.736 181.083 150.064C186.427 157.274 194.668 160.93 205.576 160.93C230.87 160.93 234.646 178.533 234.646 189.03",
    stroke: "#656B76",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.129 123.819C118.567 113.43 113.081 101.668 113.081 91.5526V70.3743C113.081 48.0773 131.227 29.9337 153.534 29.9337C175.841 29.9337 193.987 48.0773 193.987 70.3743V91.5526C193.987 101.672 188.501 113.43 178.94 123.819C170.467 133.026 160.259 139.207 153.534 139.207C146.81 139.207 136.601 133.022 128.129 123.819Z",
    stroke: "#656B76",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M303.5 131.742C274.254 105.386 218.043 87.5469 153.5 87.5469C88.9571 87.5469 32.7457 105.391 3.5 131.742",
    fill: "#00C707",
    fillOpacity: 0.32
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M303.5 131.742C274.254 105.386 218.043 87.5469 153.5 87.5469C88.9571 87.5469 32.7457 105.391 3.5 131.742",
    stroke: "#00C707",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoVerificationImg);
export default __webpack_public_path__ + "static/media/VideoVerificationImg.2e1e1cbb931fc46d291c7ff17684cea9.svg";
export { ForwardRef as ReactComponent };